<!-- MAIN CONTAINER -->
<div class="d-flex flex-column vh-100">

    <!-- FIXED SPACE FOR MAIN NAV BAR-->
    <div class="container">
        <div class="row my-3 py-3">
        </div>
    </div>

    <!-- FUNCTION BUTTONS CONTAINER -->
    <div class="container">

        <div class="row justify-content-center mt-4">

            <div *ngFor="let home of filteredHomes; let i = index" class="card fixed-width m-4 p-0">

                <a [routerLink]="['/'+home.url]" class="text-decoration-none text-center" *ngIf="!cardOpen[i]">
                    <div class="card-body ">
                        <div class="circle-background tamanio-principal color-{{ home.color}}">
                            <i class="bi {{home.icono}} fs-1 icon-color-{{home.color}} letra-inicial"></i>
                        </div>
                        <h4 class="card-title text-body-secondary">{{home.nombre}}</h4>
                    </div>
                </a>

                <a *ngIf="home.contadores === true" class="text-center" (click)="toggleCard(i, home.nameContador)" role="button">
                    <i class="bi" [ngClass]="cardOpen[i] ? 'bi-chevron-down' : 'bi-chevron-up'"></i>
                </a>

                <div class="card-title cursor-seleccionar" [ngClass]="{'show': cardOpen[i], 'hidden': !cardOpen[i]}" [routerLink]="['/'+home.url]">
                    <div class="row align-items-center text-center">
                        <div class="col-3">

                            <div class="circle-background tamanio-secundario color-{{ home.color}}" [ngClass]="home.color">
                                <i class="bi {{home.icono}} fs-1 icon-color-{{home.color}} letra-secundaria"></i>
                            </div>

                        </div>
                        <div class="col-9">
                            <h5 class="m-0 text-center">{{home.nombre}}</h5>
                        </div>
                    </div>
                </div>

                <div class="card-body" [ngClass]="{'show': cardOpen[i], 'hidden': !cardOpen[i]}">

                    <div *ngFor="let contador of mostrarContadores; let last = last" class="row cursor-seleccionar" (click)="handleClick(home.url, contador.busqueda)" [ngClass]="{ 'mb-2 pb-2 border-bottom': !last }">
                        <div class="col-8">
                            <h6 class="text-muted">{{contador.nombre}}:</h6>
                        </div>
                        <div class="col-4 text-end">

                            <h6 [ngClass]="'text-' + contador.color"> {{ contador[home.nameContador + 'cantidad'] }} </h6>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    </div>

    <div class="container">
        <div class="row mb-4 pb-4">
        </div>
    </div>

</div>
<!-- END MAIN CONTAINER -->